import React, { useContext } from 'react';
import styled from 'styled-components';
import { CheckBox, FlexColumn } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { applyFilter } from '@ubeya/shared-web/utils/filters';
import { FILTERS_IDS } from '@ubeya/shared/constants';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import { COMPASS_DE_ORGANIZATION_ID } from '@ubeya/shared/utils/accounts';

const Container = styled(FlexColumn)`
  margin: 10px 5px 5px;
`;

export const hasEarningsLimitFilter = (filters) =>
  (filters?.basic || []).some(({ id }) => id === FILTERS_IDS.NOT_EXCEEDING_EARNINGS_LIMIT);

export const applyEarningsLimitFilter = ({ filters, shiftId, checked }) =>
  applyFilter({
    type: 'basic',
    id: FILTERS_IDS.NOT_EXCEEDING_EARNINGS_LIMIT,
    value: checked ? shiftId : null,
    allFilters: filters || {}
  });

const EarningsLimitCheckBox = ({ name, value, onChange }) => {
  const { t } = useContext(ConfigContext);
  const {
    config: { organizationId }
  } = useAccount();

  if (organizationId !== COMPASS_DE_ORGANIZATION_ID) {
    return null;
  }

  return (
    <Container>
      <CheckBox name={name} label={t('notPublishShiftsToExceedingEarningsLimit')} value={value} onChange={onChange} />
    </Container>
  );
};

export default EarningsLimitCheckBox;
